(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/SessionCreationRequest', '../model/Nothing', '../model/Metadata', '../model/ExtTransaction', '../model/ExtSession', '../model/SessionContentParam', '../model/SessionUpdateRequest', '../model/SessionExternalUrlRequest'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/SessionCreationRequest'), require('../model/Nothing'), require('../model/Metadata'), require('../model/ExtTransaction'), require('../model/ExtSession'), require('../model/SessionContentParam'), require('../model/SessionUpdateRequest'), require('../model/SessionExternalUrlRequest'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.VsessionApi = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.SessionCreationRequest, root.SmartCsV2Sdk.Nothing, root.SmartCsV2Sdk.Metadata, root.SmartCsV2Sdk.ExtTransaction, root.SmartCsV2Sdk.ExtSession, root.SmartCsV2Sdk.SessionContentParam, root.SmartCsV2Sdk.SessionUpdateRequest, root.SmartCsV2Sdk.SessionExternalUrlRequest);
  }
}(this, function(ApiClient, SessionCreationRequest, Nothing, Metadata, ExtTransaction, ExtSession, SessionContentParam, SessionUpdateRequest, SessionExternalUrlRequest) {
  'use strict';

  /**
   * Vsession service.
   * @module api/VsessionApi
   * @version 2.0.624
   */

  /**
   * Constructs a new VsessionApi. 
   * @alias module:api/VsessionApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the createSession operation.
     * @callback module:api/VsessionApi~createSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a session with the given id
     * @param {module:model/SessionCreationRequest} request Session creation object `com.smarttech.cs.session.models.SessionCreationRequest
     * @param {module:api/VsessionApi~createSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.createSession = function(request, callback) {
      var postBody = request;

      // verify the required parameter 'request' is set
      if (request == undefined || request == null) {
        throw "Missing the required parameter 'request' when calling createSession";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/session', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getMetadata operation.
     * @callback module:api/VsessionApi~getMetadataCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get metadata for a content in a given session
     * @param {String} sessionId a session id
     * @param {String} contentId Resource id
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.readFull Read full tree
     * @param {module:api/VsessionApi~getMetadataCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.getMetadata = function(sessionId, contentId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'sessionId' is set
      if (sessionId == undefined || sessionId == null) {
        throw "Missing the required parameter 'sessionId' when calling getMetadata";
      }

      // verify the required parameter 'contentId' is set
      if (contentId == undefined || contentId == null) {
        throw "Missing the required parameter 'contentId' when calling getMetadata";
      }


      var pathParams = {
        'sessionId': sessionId,
        'contentId': contentId
      };
      var queryParams = {
        'readFull': opts['readFull']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/v2/session/{sessionId}/resources/{contentId}/metadata', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getProcessStatus operation.
     * @callback module:api/VsessionApi~getProcessStatusCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get Processing Status for a uploaded content
     * @param {String} sessionId a session id
     * @param {String} contentId Resource id
     * @param {String} transactionId Transaction id
     * @param {module:api/VsessionApi~getProcessStatusCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.getProcessStatus = function(sessionId, contentId, transactionId, callback) {
      var postBody = null;

      // verify the required parameter 'sessionId' is set
      if (sessionId == undefined || sessionId == null) {
        throw "Missing the required parameter 'sessionId' when calling getProcessStatus";
      }

      // verify the required parameter 'contentId' is set
      if (contentId == undefined || contentId == null) {
        throw "Missing the required parameter 'contentId' when calling getProcessStatus";
      }

      // verify the required parameter 'transactionId' is set
      if (transactionId == undefined || transactionId == null) {
        throw "Missing the required parameter 'transactionId' when calling getProcessStatus";
      }


      var pathParams = {
        'sessionId': sessionId,
        'contentId': contentId,
        'transactionId': transactionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/v2/session/{sessionId}/resources/{contentId}/status/{transactionId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getSession operation.
     * @callback module:api/VsessionApi~getSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ExtSession} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get session info
     * @param {String} sessionId Session id
     * @param {module:api/VsessionApi~getSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/ExtSession}
     */
    this.getSession = function(sessionId, callback) {
      var postBody = null;

      // verify the required parameter 'sessionId' is set
      if (sessionId == undefined || sessionId == null) {
        throw "Missing the required parameter 'sessionId' when calling getSession";
      }


      var pathParams = {
        'sessionId': sessionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = ExtSession;

      return this.apiClient.callApi(
        '/v2/session/{sessionId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the linkNode operation.
     * @callback module:api/VsessionApi~linkNodeCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This method is used to link nodes.
     * We can add a node as a child to another node.\n For now we only allow an image to be added under NB and a workspace under a lesson.\n This particular endpoint allows anonymous users as well as the signed in user within\n a session to link a resource uploaded to the session to another resource within the\n session and the life cycle of this session follows its parent.\n\n &lt;b&gt;SLSO Contents Only&lt;/b&gt;
     * @param {String} sessionId 
     * @param {String} childId id of the node that needs to be linked another another node
     * @param {String} parentId id of the node that another node gets linked to
     * @param {module:api/VsessionApi~linkNodeCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.linkNode = function(sessionId, childId, parentId, callback) {
      var postBody = null;

      // verify the required parameter 'sessionId' is set
      if (sessionId == undefined || sessionId == null) {
        throw "Missing the required parameter 'sessionId' when calling linkNode";
      }

      // verify the required parameter 'childId' is set
      if (childId == undefined || childId == null) {
        throw "Missing the required parameter 'childId' when calling linkNode";
      }

      // verify the required parameter 'parentId' is set
      if (parentId == undefined || parentId == null) {
        throw "Missing the required parameter 'parentId' when calling linkNode";
      }


      var pathParams = {
        'sessionId': sessionId,
        'childId': childId,
        'parentId': parentId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/v2/session/{sessionId}/resources/{childId}/link/{parentId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the linkResources operation.
     * @callback module:api/VsessionApi~linkResourcesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Link existing resources to the given session
     * @param {String} sessionId Session id
     * @param {Array.<module:model/SessionContentParam>} request request to link resource to a session `java.util.List&lt;com.smarttech.cs.session.models.SessionContentParam&gt;
     * @param {module:api/VsessionApi~linkResourcesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.linkResources = function(sessionId, request, callback) {
      var postBody = request;

      // verify the required parameter 'sessionId' is set
      if (sessionId == undefined || sessionId == null) {
        throw "Missing the required parameter 'sessionId' when calling linkResources";
      }

      // verify the required parameter 'request' is set
      if (request == undefined || request == null) {
        throw "Missing the required parameter 'request' when calling linkResources";
      }


      var pathParams = {
        'sessionId': sessionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/session/{sessionId}/resources/link', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the putLessonPersistDoc operation.
     * @callback module:api/VsessionApi~putLessonPersistDocCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upload a lesson persist protocol document to be stored in S3
     * @param {String} sessionId Session id
     * @param {File} fileStream 
     * @param {String} contentParam 
     * @param {Object} opts Optional parameters
     * @param {String} opts.extMetadata 
     * @param {module:api/VsessionApi~putLessonPersistDocCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.putLessonPersistDoc = function(sessionId, fileStream, contentParam, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'sessionId' is set
      if (sessionId == undefined || sessionId == null) {
        throw "Missing the required parameter 'sessionId' when calling putLessonPersistDoc";
      }

      // verify the required parameter 'fileStream' is set
      if (fileStream == undefined || fileStream == null) {
        throw "Missing the required parameter 'fileStream' when calling putLessonPersistDoc";
      }

      // verify the required parameter 'contentParam' is set
      if (contentParam == undefined || contentParam == null) {
        throw "Missing the required parameter 'contentParam' when calling putLessonPersistDoc";
      }


      var pathParams = {
        'sessionId': sessionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'fileStream': fileStream,
        'contentParam': contentParam,
        'extMetadata': opts['extMetadata']
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/session/{sessionId}/resources/upload/lpp', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateSession operation.
     * @callback module:api/VsessionApi~updateSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a session
     * @param {String} sessionId Session ID
     * @param {module:model/SessionUpdateRequest} request session creation object `com.smarttech.cs.session.models.SessionUpdateRequest
     * @param {module:api/VsessionApi~updateSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.updateSession = function(sessionId, request, callback) {
      var postBody = request;

      // verify the required parameter 'sessionId' is set
      if (sessionId == undefined || sessionId == null) {
        throw "Missing the required parameter 'sessionId' when calling updateSession";
      }

      // verify the required parameter 'request' is set
      if (request == undefined || request == null) {
        throw "Missing the required parameter 'request' when calling updateSession";
      }


      var pathParams = {
        'sessionId': sessionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/session/{sessionId}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadNewResource operation.
     * @callback module:api/VsessionApi~uploadNewResourceCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upload content to the given session
     * @param {String} sessionId Session id
     * @param {File} fileStream 
     * @param {String} contentParam 
     * @param {Object} opts Optional parameters
     * @param {String} opts.extMetadata 
     * @param {module:api/VsessionApi~uploadNewResourceCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.uploadNewResource = function(sessionId, fileStream, contentParam, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'sessionId' is set
      if (sessionId == undefined || sessionId == null) {
        throw "Missing the required parameter 'sessionId' when calling uploadNewResource";
      }

      // verify the required parameter 'fileStream' is set
      if (fileStream == undefined || fileStream == null) {
        throw "Missing the required parameter 'fileStream' when calling uploadNewResource";
      }

      // verify the required parameter 'contentParam' is set
      if (contentParam == undefined || contentParam == null) {
        throw "Missing the required parameter 'contentParam' when calling uploadNewResource";
      }


      var pathParams = {
        'sessionId': sessionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'fileStream': fileStream,
        'contentParam': contentParam,
        'extMetadata': opts['extMetadata']
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/session/{sessionId}/resources/upload', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the uploadToSessionViaUrl operation.
     * @callback module:api/VsessionApi~uploadToSessionViaUrlCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Upload content to the given session via an external url
     * @param {String} sessionId Session id
     * @param {module:model/SessionExternalUrlRequest} sessionExternalUrlRequest 
     * @param {module:api/VsessionApi~uploadToSessionViaUrlCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.uploadToSessionViaUrl = function(sessionId, sessionExternalUrlRequest, callback) {
      var postBody = sessionExternalUrlRequest;

      // verify the required parameter 'sessionId' is set
      if (sessionId == undefined || sessionId == null) {
        throw "Missing the required parameter 'sessionId' when calling uploadToSessionViaUrl";
      }

      // verify the required parameter 'sessionExternalUrlRequest' is set
      if (sessionExternalUrlRequest == undefined || sessionExternalUrlRequest == null) {
        throw "Missing the required parameter 'sessionExternalUrlRequest' when calling uploadToSessionViaUrl";
      }


      var pathParams = {
        'sessionId': sessionId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/session/{sessionId}/resources/externalUrl', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
